import { useMutateUpdateTextMaterialTag } from '@@partner:graphql/mutation/textMaterial/updateTextMaterialTag.gql'
import { useFetchAllTextMaterialTags } from '@@partner:graphql/query/textMaterial/tags/allTextMaterialTags.gql'
import { RsuiteItemDataType } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import React from 'react'
import { TagPicker } from 'rsuite'
import { InputItemDataType } from 'rsuite/esm/InputPicker'

type Props = {
  value: GQL_ID[]
  onSelect: (value: GQL_ID[]) => void
}

export default function TextMaterialTagPicker ({
  value,
  onSelect
}: Props) {
  const { data, loading, error, refetch } = useFetchAllTextMaterialTags({
    pager: {
      page: 1,
      limit: 100
    },
    sort: {
      fieldName: 'name',
      direction: 0
    }
  })

  const [ createTag, { data: updatedTag, loading: updatingTag } ] = useMutateUpdateTextMaterialTag()

  const allTags = data?.allTextMaterialTags?.edges.map((item: any) => ({
    label: item?.name,
    value: item?.id
  }))

  const handleSelect = (_: GQL_ID[], item: RsuiteItemDataType) => {
    if (item.label !== item.value && item.value) {
      if (value.includes(item.value)) {
        onSelect(value.filter((id) => id !== item.value))
      }
      else {
        onSelect([ ...value, item.value ])
      }
    }
  }

  const handleRemoveTag = (item: GQL_ID) => {
    onSelect(value.filter((id) => id !== item))
  }

  const handleCreateTag = async (_: string[], item: InputItemDataType) => {
    const result = await createTag({
      variables: {
        textMaterialTagInfo: {
          name: item.label as string,
          title: item.label as string
        },
        upsert: true
      }
    })
    
    if (result.data?.updateTextMaterialTag.id) {
      await refetch()
      onSelect([ ...value, result.data.updateTextMaterialTag.id ])
    }
  }

  const handleClean = () => {
    onSelect([])
  }

  if (!data || !allTags) {
    return null
  }

  return (
    <TagPicker
      size='md'
      data={allTags}
      creatable
      onCreate={handleCreateTag}
      onSelect={handleSelect}
      onTagRemove={handleRemoveTag}
      onClean={handleClean}
      value={value}
      placeholder="Выберите теги"
    />
  )
}